import { render } from "./listCom.vue?vue&type=template&id=1ff9cb82"
import script from "./listCom.vue?vue&type=script&lang=js"
export * from "./listCom.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__